import { useMemo } from 'react'

import { formatPrice } from '@/shared/lib/utils/price/format-price'

export type UseBonusPanelContentParams = {
	isAuthorized?: boolean
	isJuridicalUser?: boolean
	totalBonusesCount: number
}

export type UseBonusPanelContentReturn = {
	title: string
	subTitle: string | JSX.Element
}

/**
 * Хук для генерации текстового контента панели бонусов
 */
export const useBonusPanelContent = ({
	isAuthorized,
	isJuridicalUser,
	totalBonusesCount
}: UseBonusPanelContentParams): UseBonusPanelContentReturn => {
	const title = useMemo(() => {
		if (!isAuthorized) {
			return 'Получайте больше выгоды!'
		}

		if (!totalBonusesCount) {
			return 'У вас пока нет бонусов'
		}

		return `У вас ${formatPrice(totalBonusesCount, 'decimal')} бонусов`
	}, [isAuthorized, totalBonusesCount])

	const subTitle = useMemo(() => {
		// Неавторизованный юр.лицо
		if (!isAuthorized && isJuridicalUser) {
			return (
				<>
					<span>Авторизуйтесь</span>, чтобы изменить счёт для зачисления бонусов за этот заказ
				</>
			)
		}

		// Неавторизованный физ.лицо
		if (!isAuthorized && !isJuridicalUser) {
			return (
				<>
					<span>Авторизуйтесь </span> для зачисления и списания бонусов за этот заказ
				</>
			)
		}

		// Авторизован, но нет бонусов
		if (!totalBonusesCount) {
			return 'Копите бонусы и используйте их в последующих заказах'
		}

		// Авторизован и есть бонусы
		return 'Использовать бонусы вы сможете в оформлении заказа'
	}, [isAuthorized, isJuridicalUser, totalBonusesCount])

	return { title, subTitle }
}
